import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { formatNum } from "@/lib/api";

// Classifies the material difference found at Receive time into an accounting treatment
// (Approved Wastage / Recoverable Wastage / Shortage / Custom Adjustment) before the job can complete.
export const ReconcileDialog = ({ open, onClose, detail, reconcileForm, setReconcileForm, onClassificationChange, fineBalance, onSubmit }) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent data-testid="job-reconcile-dialog" className="max-w-md">
      <DialogHeader>
        <DialogTitle>Reconcile Material — {detail?.job_no}</DialogTitle>
        <DialogDescription>
          Issued (fine): {formatNum(detail?.reconciliation?.gold_issued_fine_g)}g · Returned (fine): {formatNum(detail?.reconciliation?.gold_returned_fine_g)}g · Difference: {formatNum(detail?.reconciliation?.difference_g)}g
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3">
        <div>
          <Label className="text-xs">Classification</Label>
          <Select value={reconcileForm.classification} onValueChange={onClassificationChange}>
            <SelectTrigger data-testid="job-reconcile-classification-select" className="mt-1"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="approved_wastage">Approved Wastage (accepted loss)</SelectItem>
              <SelectItem value="recoverable_wastage">Recoverable Wastage (deduct from karigar)</SelectItem>
              <SelectItem value="shortage">Shortage (deduct from karigar)</SelectItem>
              <SelectItem value="adjustment">Custom Adjustment</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {reconcileForm.classification !== "approved_wastage" && (
          <div><Label className="text-xs">{reconcileForm.classification === "adjustment" ? "Adjustment Amount (rupees, +debit / -credit)" : "Deduction Amount (rupees)"}</Label><Input data-testid="job-reconcile-amount-input" type="number" value={reconcileForm.adjustment_amount} onChange={(e) => setReconcileForm({ ...reconcileForm, adjustment_amount: e.target.value })} className="mt-1 font-mono" /></div>
        )}
        <div>
          <Label className="text-xs">Approved Loss/Recovery (g)</Label>
          <Input data-testid="job-reconcile-approved-loss-input" type="number" value={reconcileForm.approved_loss_recovery_g} onChange={(e) => setReconcileForm({ ...reconcileForm, approved_loss_recovery_g: e.target.value })} className="mt-1 font-mono" />
          <p className="text-[10px] text-muted-foreground mt-1">Fine gold grams formally written off/recovered for this classification.</p>
        </div>
        <div className="rounded-md border border-border bg-[#F4EBDD] p-2 flex items-center justify-between text-sm">
          <span>Fine Balance (Issued − Received − Approved)</span>
          <span data-testid="job-reconcile-fine-balance-preview" className={`font-mono ${Math.abs(fineBalance) > 0.001 ? "text-[#7A1F1F]" : "text-[#1F5B2E]"}`}>{formatNum(fineBalance)}g</span>
        </div>
        <div><Label className="text-xs">Note</Label><Textarea value={reconcileForm.note} onChange={(e) => setReconcileForm({ ...reconcileForm, note: e.target.value })} rows={2} className="mt-1" /></div>
      </div>
      <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button><Button data-testid="job-reconcile-submit" onClick={onSubmit}>Save Classification</Button></DialogFooter>
    </DialogContent>
  </Dialog>
);
